<template>
  <div>
    <!-- Header -->
    <Header
      v-if="type==0"
      :headerTitle="$t('m.staySubmitOrder.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>
    <Header
      v-if="type==1"
      :headerTitle="$t('m.staySubmitOrder.title')"
      :hasBackBtn="false"
      :rightIconSrc="require('../assets/img/wode.png')"
      :onRightBtnClick="userCenter"
      :iconShow="true"
    ></Header>
    <!-- order Info -->
    <div class="main-container" style="height: calc(100% - 50px)">
      <section>
        <div class="cardId">
          <h6>{{result.licenseplate}}</h6>
        </div>
        <div class="cardAddress">
          <h6>{{$i18n.locale==='zh_CN' ? result.parkingName : result.parkingEnName}}</h6>
          <p>{{$i18n.locale==='zh_CN' ? result.parkingAddress : result.parkingEnAddress}}</p>
          <div v-if="result.parkingSpace && result.parkingSpace.selfService === 1" class="space-name">车位号: {{ result.parkingSpace.spaceName }}</div>
        </div>
        <div v-if="result.parkingSpace && result.parkingSpace.selfService === 1" class="cardAddress">
          <h6>终端信息</h6>
          <div class="equipment-desc-container">
            <div v-if="result.parkingSpace.describe1" class="equipment-desc">{{ result.parkingSpace.describe1 }}</div>
            <div v-if="result.parkingSpace.describe2" class="equipment-desc">{{ result.parkingSpace.describe2 }}</div>
            <div v-if="result.parkingSpace.describe3" class="equipment-desc">{{ result.parkingSpace.describe3 }}</div>
          </div>
          <h6 style="margin-top: 8px">价格信息</h6>
          <div class="space-name">{{ result.chargeUnitAmount }}元/度</div>
        </div>
        <div class="infoCard">
          <p class="borderba">{{$t('m.staySubmitOrder.inTitle')}}</p>
          <div style="padding-top:10px">
            <h6>{{result.appointInTime}}</h6>
            <p v-if="$t('m.staySubmitOrder.language')=='zh_CN'">{{$t('m.staySubmitOrder.tips')}}</p>
            <p v-if="$t('m.staySubmitOrder.language')=='en_US'">&nbsp;</p>
          </div>
          <h6 class="dateAppche">{{appointTime}}</h6>
          <p class="borderba">{{$t('m.staySubmitOrder.outTitle')}}</p>
          <div style="border:0;padding-top:10px;">
            <h6>{{result.appointOutTime}}</h6>
          </div>
        </div>
        <div class="money">
          <p>
           {{$t('m.staySubmitOrder.goPay')}}
            <span>{{result.amount?result.amount:0}}{{$t('m.staySubmitOrder.CNY')}}</span>
          </p>
        </div>
         <p v-if="$t('m.submitOrder.language')=='en_US'" style=" font-size: 13px;color: #666;text-align: left;">Please enter on time, in case no parking lot is available</p>
         <p v-if="result.disperserTimeId != null" style=" font-size: 13px;color: #666;text-align: left;">
          <span v-if="$t('m.staySubmitOrder.language')=='zh_CN'"> 温馨提示: 请在停车结束后到达{{result.voucherAddress}}领取出场凭证</span>
          <span v-if="$t('m.submitOrder.language')=='en_US'"> Tips: Please arrive at{{result.voucherAddress}}to get the exit voucher after the service is over.</span>
           </p>
      </section>
      <!-- footer -->
      <footer>
        <b-btn
            v-if="result.entranceWay === 1"
            variant="primary"
            v-b-modal.enter-disperser-modal
            style="width:100%;line-height:30px;"
        >{{$t('m.staySubmitOrder.confimButtom')}}</b-btn>
        <p></p>
        <b-btn
          v-show="hideButton"
          v-b-modal.modal-center
          style="width:100%;line-height:30px;"
          @click="LoadOrderConfirm()"
        >{{$t('m.staySubmitOrder.cancelButton')}}</b-btn>

        <div v-if="result.parkingSpace && result.parkingSpace.selfService === 1" class="footer-tip" @click="handleLockTip">地锁未降下？</div>

        <!-- 取消订单弹框 -->
        <b-modal
          id="modal-center"
          class="cancelOrders"
          :cancel-title="$t('m.staySubmitOrder.no')"
          :ok-title="$t('m.staySubmitOrder.yes')"
          @ok="onCancelOrderConfirm"
        >
          <p class="my-4" style="margin-bottom:5px !important;padding:0 25px;font-size:15px;" v-if="$t('m.staySubmitOrder.language')=='zh_CN'">
            当前取消订单将扣款{{confimList.deductionAmout}}{{$t('m.staySubmitOrder.CNY')}}
            <br>确定取消订单吗？
          </p>
          <p class="my-4" style="margin-bottom:5px !important;padding:0 25px;font-size:15px;" v-if="$t('m.staySubmitOrder.language')=='en_US'">
          You'll be charged {{confimList.deductionAmout}} CNY if you cancel the order<br>Confirm to cancel the order?
          </p>
          <p style="padding:0 35px;font-size:15rpx;color: #0066B1;" @click="ruler()">{{$t('m.staySubmitOrder.goRuler')}}&nbsp;></p>
        </b-modal>
        <b-modal
            hide-header
            ref="selfOperation"
            class="cancelOrders"
            :ok-title="$t('m.staySubmitOrder.buttonModel')"
            ok-only
        >
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >{{$t('m.submitOrder.language')=='en_US'?'Tips':'温馨提示'}}</p>
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >
            <span v-if="$t('m.staySubmitOrder.language')=='zh_CN'"> 请在停车结束后到达{{result.voucherAddress}}领取出场凭证</span>
          <span v-if="$t('m.submitOrder.language')=='en_US'"> Please arrive at{{result.voucherAddress}}to get the exit voucher after the service is over.</span>
          </p>
        </b-modal>
        <b-modal
            hide-header
            id="enter-disperser-modal"
            class="cancelOrders"
            cancel-title="取消"
            ok-title="确认"
            @ok="handleManualEnter()"
        >
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >是否确认进场</p>
        </b-modal>
      </footer>
    </div>
    <!-- phone mobile -->
    <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>

    <b-modal ref="lock-tip" id="lock-tip" ok-only no-close-on-backdrop class="notice" static ok-title="我知道了"
             cancel-title="选择其他场站" @ok="goVehicleLicenseAuth()" @cancel="handleVehicleLicenseCancel">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
<!--      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:12px;">
        {{ result.parkingSpace.spaceName }} 车位空闲, 地锁已升起,
        若地锁未自动降下, 请点击 <span class="lock-down-tip" @click="handleDownLock">降下地锁</span>,
        若点击后地锁仍未降下, 请拨打<span class="lock-down-tip" @click="handleCallLockService">4001150606</span>
      </p>-->
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:12px;">
        若地锁未降下，请拨打<span class="lock-down-tip" @click="handleCallLockService">4001150606</span>
      </p>
    </b-modal>

    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>

  </div>
</template>
<script>
import {
  cancelOrder,
  orderListByDetails,
  cancelOrderConfirm,
  orderStatus,
  manualEnter
} from "../api/order.js";
import {dateAdd,formatDate,hourtoMinute}from "@/utils/DateFomatUtil";
export default {
  name: "StaySubmitOrder",
  data() {
    return {
      orderId: "", //订单Id
      result: {}, //数据
      phone: "400-115-0606", //手机号
      confimList: "", //取消订单
      appointTime: "", //预约时长
      longitude: 0, //当前经度
      latitude: 0, //当前维度
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      hideButton: true,
      ostatus: null,
      type: "0",
      noticeTitle: '',
      noticeInfo: ''
    };
  },
  methods: {
    //取消订单
    onCancelOrderConfirm: function() {
      cancelOrder({ orderId: this.orderId }).then(
        response => {
          if (response.data.status == 200) {
            if (this.ostatus != null) {
              clearInterval(this.ostatus);
            }
            this.hideButton = false;
            this.tipShow = "1" + Math.random() * 1000;
            this.message =this.$t('m.staySubmitOrder.cancelSuccess');
            this.tipType = "success";
            setTimeout(_ => {
              if (this.type == 0) {
                window.history.back();
              } else {
                this.$router.push("/");
              }
            }, 1100);
          } else {
            if (this.ostatus != null) {
              clearInterval(this.ostatus);
            }
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
            this.message = response.data.message;
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //用户头像操作
    userCenter: function() {
      if (this.ostatus != null) {
        clearInterval(this.ostatus);
      }
      this.$router.push("/userCenter");
    }, //如果取消看扣费多少
    LoadOrderConfirm: function() {
      cancelOrderConfirm({ orderId: this.orderId }).then(
        response => {
          if (response.data.status == 200) {
            this.confimList = response.data.result;
          } else {
            if (this.ostatus != null) {
              clearInterval(this.ostatus);
            }
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
            this.message = response.data.message;
          }
        },
        err => {
          reject(err);
        }
      );
    },
    handleLockTip() {
      this.noticeTitle = '温馨提示'
      this.$refs["lock-tip"].show();
    },
    handleDownLock() {
      setTimeout(() => {
        this.message = '操作成功'
        this.tipType = "success";
        // this.tipShow = "1" + Math.random() * 1000;
      }, 1000)
    },
    handleCallLockService() {
      window.location.href = "tel://4001150606";
    },
    ruler: function() {
      this.$router.push("/ruler");
    },
    handleManualEnter(){
      manualEnter({id:this.orderId}).then(response => {
        if (response.data.status == 200) {
          this.$router.push("/Time/" + this.orderId);
        } else {
          this.tipShow = "1" + Math.random() * 1000;
          this.tipType = "warning";
          this.message = "入场失败";
        }
      })
    },
    //加载数据
    loadPrePayOrderInfo: function() {
      setTimeout(() => {
        orderListByDetails({
          orderId: this.orderId,
          latitude: this.latitude,
          longitude: this.longitude
        }).then(
          response => {
            if (response.data.status == 200) {
              this.result = response.data.result;
              //预约时长转换成秒
              this.appointTime =hourtoMinute(this.result.appointTime,this.$t('m.dataTime.hour'),this.$t('m.dataTime.minute'));
              if (this.result.disperserTimeId != null) {
                this.$refs['selfOperation'].show();
              }
            } else {
              if (this.ostatus != null) {
                clearInterval(this.ostatus);
              }
              this.tipShow = "1" + Math.random() * 1000;
              this.tipType = "warning";
              this.message = response.data.message;
            }
          },
          err => {
            reject(err);
          }
        );
      },100);
    }, //轮询订单状态
    orderStatus() {
      let this_s = this;
      this.ostatus = setInterval(function() {
        orderStatus({ orderId: this_s.orderId }).then(response => {
          let data = response.data;
          if (data.status == 200) {
            if (data.result.status == 3) {
              this_s.$router.push("/Time/" + this_s.orderId);
              clearInterval(this_s.ostatus);
            }else if (data.result.status == 4) {
				this_s.$router.push("/");
			}
          } else {
            if (this.ostatus != null) {
              clearInterval(this.ostatus);
            }
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
            this.message = response.data.message;
          }
        });
      }, 4000);
    },
    call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  created() {
    this.orderId = this.$route.params.orderId;
    this.type = this.$route.params.type;
    this.loadPrePayOrderInfo();
    this.orderStatus();
  },
  destroyed() {
    if (this.ostatus != null) {
      clearInterval(this.ostatus);
    }
  }
};
</script>
<style>
section {
  margin-bottom: 36px !important;
}
section .cardId {
  border-bottom: 2px solid #efefef;
  padding: 5px 0;
  text-align: left;
}
section .cardAddress {
  padding: 20px 0;
  text-align: left;
  border-bottom: 2px solid #efefef;
}
section .terminal-info {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  border-bottom: 2px solid #efefef;
}
.charge-price-info {
  display: flex;
  flex-direction: row;
}
.price-tip {

}
section .cardAddress h6 {
  margin: 0 auto;
  padding: 0px;
}
section .cardAddress p {
  font-size: 13px;
  width: 85%;

  display: inline-block;
  color: #666;
}
section .cardAddress .equipment-desc-container {
  display: flex !important;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  margin: 8px 0 16px 0;
}
section .infoCard {
  text-align: left;
  padding: 20px 0;
  /* padding-bottom: 25px; */
  border-bottom: 2px solid #efefef;
}
section .infoCard .dateAppche {
  padding-top: 18px;
  color: #0066B1;

  padding-left: 5px;
}
section .infoCard .borderba {
  background-color: #0066B1;
  border-radius: 15px;
  display: inline-block;
  padding: 0 13px;
  padding-top: 2px;
  color: #fff;
  font-size: 14px;
  /* margin-top: 14px; */
  margin-top: 11px;
}
section .infoCard div {
  display: inline-block;
  text-align: right;
  float: right;
  /* width: 80%; */
   width: 73%;
  border-bottom: 2px solid #efefef;
}
section .infoCard div p {
  font-size: 13px;
  color: #666;
  padding-bottom: 10px;
}
section .money {
  text-align: left;
  padding: 10px 0;
  border-bottom: 2px solid #efefef;
}
section .money span {
  display: inline-block;
  text-align: right;
  float: right;
}
.cancelOrders .modal {
  top: auto !important;
  bottom: 40% !important;
  margin: 0 10%;
}
.cancelOrders .modal .modal-dialog .modal-body {
  margin: 0px;
  padding: 0px;
}
.cancelOrders .modal .modal-dialog .modal-body .my-4 {
  font-size: 20px;
  color: #666;
}
.cancelOrders header {
  padding: 0px;
}
.cancelOrders .modal-footer {
  margin-left: 0px;
}
.cancelOrders footer {
  text-align: center;
}

footer {
  bottom: 0px;
  padding: 0 5%;
}
.space-name {
  margin-top: 8px;
  font-size: 24px;
  font-weight: 500;
  color: #0061B1;
  line-height: 24px;
}
.footer-tip {
  margin-top: 8px;
  width: 100%;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #0061B1;
  line-height: 14px;
  text-align: left;
}
.lock-down-tip {
  color: #0061B1;
}
.equipment-desc {
  width: 100%;
  text-align: left;
}
</style>



